import { skipToken } from "@reduxjs/toolkit/dist/query";
import { useParams } from "react-router-dom";
import { useGetTransportByIdQuery } from "src/api/rtk/base/slices/transportApiSlice";

export function useTransportInfo() {

    const { transportId } = useParams<{ transportId: string }>();

    const {
        data: transportInfo,
        isFetching: isFetchingTransportInfo,
        isError: isTransportInfoError
    } = useGetTransportByIdQuery(transportId ? { id: transportId } : skipToken, {
        selectFromResult: ({ data, ...rest }) => ({
            data: data?.[0],
            ...rest
        })
    })

    return { data: transportInfo, isLoadingMainData: isFetchingTransportInfo, isError: isTransportInfoError }
}